import valuation from './valuation';

export default {
  valuation,
};
